import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[580px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20background%20with%20abstract%20film%20strip%20and%20projector%20light%20beam%20elements%2C%20warm%20golden%20and%20amber%20light%20streaks%20on%20deep%20charcoal%20background%2C%20theater%20atmosphere%2C%20dramatic%20cinematic%20lighting%2C%20elegant%20movie%20themed%20composition%2C%20rich%20contrast%2C%20professional%20cinematography%20style%2C%20no%20text%20or%20logos%2C%20smooth%20gradients%2C%20luxurious%20dark%20aesthetic&width=1920&height=900&seq=hero-cinema-bg&orientation=landscape"
        alt="免费电影在线观看 - 海量高清免费电影资源"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-background-50/30 to-background-50/95" />

      <div className="relative z-10 text-center px-4 w-full max-w-[900px]">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
          <span className="w-3 h-3 flex items-center justify-center">
            <i className="ri-sparkling-2-fill text-accent-400 text-xs"></i>
          </span>
          <span className="text-xs md:text-sm font-medium text-accent-400 whitespace-nowrap">每日更新 · 海量资源 · 完全免费</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-4">
          免费电影<span className="text-accent-500">在线观看</span>
        </h1>
        <p className="text-sm md:text-base text-foreground-500 max-w-[650px] mx-auto mb-8 leading-relaxed">
          汇聚海量高清免费电影资源，涵盖国产、好莱坞、动漫、纪录片等全类型，
          无需注册、无需付费，随时随地畅享免费电影观看体验
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-play-circle-fill text-sm"></i>
            </span>
            立即观影
          </Link>
          <Link
            to="/category/sci-fi"
            className="px-8 py-3 rounded-full bg-background-200/70 text-foreground-700 font-medium text-sm hover:bg-background-300/70 transition-colors whitespace-nowrap cursor-pointer border border-background-300/50"
          >
            热门推荐
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl text-accent-400">10000+</p>
            <p className="text-xs text-foreground-500 mt-1">高清影片</p>
          </div>
          <div className="w-px h-10 bg-background-300/50" />
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl text-accent-400">30+</p>
            <p className="text-xs text-foreground-500 mt-1">影片分类</p>
          </div>
          <div className="w-px h-10 bg-background-300/50" />
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl text-accent-400">每日</p>
            <p className="text-xs text-foreground-500 mt-1">持续更新</p>
          </div>
        </div>
      </div>
    </section>
  );
}